export default "__VITE_ASSET__6a196d46__"